const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = "oyb_ref";
const OWN_KEY = "oyb_my_referral";

export function captureReferral() {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get("ref");
  if (!ref) return;
  const code = ref.toUpperCase();
  const own = getMyReferral();
  if (own?.code === code) return;
  if (localStorage.getItem(STORAGE_KEY) !== code) {
    localStorage.setItem(STORAGE_KEY, code);
    fetch(`${API}/referrals/${code}/visit`, { method: "POST" }).catch(() => {});
  }
}

export function getReferralCode() {
  return localStorage.getItem(STORAGE_KEY) || "";
}

export function trackReferralLead() {
  const code = getReferralCode();
  if (!code) return;
  fetch(`${API}/referrals/${code}/lead`, { method: "POST" }).catch(() => {});
}

export function getMyReferral() {
  try {
    return JSON.parse(localStorage.getItem(OWN_KEY) || "null");
  } catch {
    return null;
  }
}

export function saveMyReferral(data) {
  localStorage.setItem(OWN_KEY, JSON.stringify(data));
}

export function buildShareUrl(code) {
  return `${window.location.origin}/?ref=${code}`;
}
